// extracted by mini-css-extract-plugin
module.exports = {"chatMessageGiven":"ChatMessageGiven_chatMessageGiven__2sd41","message":"ChatMessageGiven_message__3x1GF"};